import { CommentActionType } from '../../../../common/comments/commentConstants';
import { getTimestamp } from '../../../../common/utils/timeUtil';

export const commentsTypingPing = ({ threadId, elementId }) => ({
    type: CommentActionType.COMMENTS_TYPING_PING,
    threadId,
    elementId,
    timestamp: getTimestamp(),
    sync: true,
});

export const commentsTypingStop = ({ threadId, elementId }) => ({
    type: CommentActionType.COMMENTS_TYPING_STOP,
    threadId,
    elementId,
    sync: true,
});
